import {
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AuthProvider } from '../providers/auth';
import { HelperProvider } from '../providers/helper';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
	constructor(
		public auth: AuthProvider,
		public helper: HelperProvider,
	) {}
	public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		const apiNode = this.helper.getNodeByUrl(request.url);

		if (apiNode && apiNode.auth && this.auth.isAuthenticated) {
			request = request.clone({
				setHeaders: {
					Authorization: `Bearer ${this.auth.getToken()}`,
				},
			});
		}
		return next.handle(request);
	}
}



// WEBPACK FOOTER //
// ./src/app/core/interceptors/token.ts